import { FC } from 'react';

import { GraphQLQuery } from '../../types';
import styles from './GraphQLQueryText.module.css';

type Props = {
  query: GraphQLQuery;
};

const GraphQLQueryText: FC<Props> = ({ query }) => {
  const body = query.request.body?.toString();

  if (!body) return null;

  const json = JSON.parse(body);

  return <pre className={styles.root}>{json.query}</pre>;
};

export default GraphQLQueryText;
